import { create } from "zustand";

export type DisplayMode = "chat" | "developer";

interface SettingsState {
  displayMode: DisplayMode;
  setDisplayMode: (mode: DisplayMode) => void;
  // Авто-озвучка ответов в текстовом чате. ВЫКЛ по умолчанию — иначе каждый
  // ответ дробится по предложениям и каждое = платный запрос Yandex TTS.
  // Кнопка ▶ под сообщением озвучивает вручную независимо от этого флага.
  autoSpeak: boolean;
  setAutoSpeak: (v: boolean) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  displayMode: (((localStorage.getItem("aicores.displayMode") as string) === "simple"
    ? "chat"
    : localStorage.getItem("aicores.displayMode")) as DisplayMode) || "chat",
  setDisplayMode: (mode) => {
    localStorage.setItem("aicores.displayMode", mode);
    set({ displayMode: mode });
  },
  autoSpeak: localStorage.getItem("aicores.autoSpeak") === "1",
  setAutoSpeak: (v) => {
    localStorage.setItem("aicores.autoSpeak", v ? "1" : "0");
    set({ autoSpeak: v });
  },
}));
